import { useInfiniteQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "app/data/common/queryKeys";
import DriverService from "app/data/drivers/driversService";

export const useDriversList = (terminal: string, search: string) => {
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isLoading,
    refetch,
    isRefetching,
    isFetchingNextPage,
    isFetching,
    isPreviousData
  } = useInfiniteQuery({
    queryKey: [QUERY_KEYS.DRIVER_LIST, search, terminal],
    queryFn: async ({ pageParam = null }) => {
      return await DriverService.getInstance().getDrivers(
        terminal,
        search,
        pageParam 
      );
    },
    getNextPageParam: (lastPage) =>
      lastPage.data?.nextCursor ?? undefined,

    refetchOnWindowFocus: false,
    retry: false,
    keepPreviousData: true
  });

  return {
    data,
    fetchNextPage,
    hasNextPage,
    isLoading,
    refetch,
    isRefetching,
    isFetchingNextPage,
    isFetching,
    isPreviousData
  };
};

